import { forEach } from "angular";
import type { Moment } from "moment-timezone";

import type { IScheduleException } from "./IScheduleException";

export class ScheduleExceptionFunctions {
    public static enhanceScheduleExceptions(exceptions: IScheduleException[], timeZone?: string) {
        forEach(exceptions, (exception) => {
            if (timeZone) {
                exception.dtStart = exception.dtStart.clone().tz(timeZone);
                exception.dtStop = exception.dtStop.clone().tz(timeZone);
            }
        });
    }

    public static enhanceScheduleException(exception: IScheduleException, timeZone?: string) {
        ScheduleExceptionFunctions.enhanceScheduleExceptions([exception], timeZone);
    }

    public static checkOverlappingRange(
        scheduleRanges: Array<{ dateStart: Moment; dateStop: Moment }>,
        dateStart: Moment,
        dateStop: Moment,
    ): boolean {
        const ranges = [
            ...scheduleRanges,
            {
                dateStart,
                dateStop,
            },
        ];

        return ranges
            .sort((a, b) => a.dateStart.diff(b.dateStart))
            .reduce(
                (result, current, idx, arr) => {
                    if (idx === 0) {
                        return result;
                    }

                    if (arr[idx - 1].dateStop >= current.dateStart) {
                        result.overlap = true;
                    }

                    return result;
                },
                { overlap: false },
            ).overlap;
    }
}
